export default __webpack_public_path__ + "static/media/1507.1df70376.png";